module.exports = __webpack_public_path__ + "img/settings-bot.dbcce37d.png";